import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import './index.css';
import './styles/main.scss';
import App from './App';
import config from './config';

// Configure Amplify with your Cognito and S3 settings
Amplify.configure({
  Auth: {
    region: config.cognito.region,
    userPoolId: config.cognito.userPoolId,
    userPoolWebClientId: config.cognito.userPoolWebClientId,
    identityPoolId: config.cognito.identityPoolId
  },
  Storage: {
    AWSS3: {
      bucket: config.storage.AWSS3.bucket,
      region: config.storage.AWSS3.region,
      level: 'public' // Changed to public for content uploads
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
